import '../FeatureFlagsContainer.css';
import React from 'react';
import { ToggleButton } from './ToggleButton';

export const FeatureFlagCard = ({ name, description, ticketLink, handleToggle, defaultSetting = false }) => {
  return (
    <div className="card">
      <h4 className="card__name">{name}</h4>
      <p className="card__description">{description}</p>
      <div className="card__bottom">
        <p className="card__ticketLink">
          {ticketLink && (
            <a href={ticketLink} target="_blank">
              Link to Ticket
            </a>
          )}
        </p>
        <ToggleButton defaultSetting={defaultSetting} handleToggle={handleToggle} />
      </div>
    </div>
  );
};
